export default __webpack_public_path__ + "static/media/OWL_NOISE.b2a14224.wav";